import { d as dateToDateString, b as subDays } from './util3.js';
import { a as addDays, c as subMonths, s as startOfMonth } from './subMonths.js';

// Note that our presets are inclusive to today, so we need to offset some ranges with 1 day
const DATE_RANGE_PRESETS = {
    '7_DAYS': {
        label: 'Last 7 days',
        value: () => [dateToDateString(subDays(new Date(), 7 - 1)), dateToDateString(new Date())],
    },
    '14_DAYS': {
        label: 'Last 14 days',
        value: () => [dateToDateString(subDays(new Date(), 14 - 1)), dateToDateString(new Date())],
    },
    '30_DAYS': {
        label: 'Last 30 days',
        value: () => [dateToDateString(subDays(new Date(), 30 - 1)), dateToDateString(new Date())],
    },
    '60_DAYS': {
        label: 'Last 60 days',
        value: () => [dateToDateString(subDays(new Date(), 60 - 1)), dateToDateString(new Date())],
    },
    '90_DAYS': {
        label: 'Last 90 days',
        value: () => [dateToDateString(subDays(new Date(), 90 - 1)), dateToDateString(new Date())],
    },
    '12_MONTHS': {
        label: 'Last 12 months',
        value: () => [dateToDateString(addDays(subMonths(new Date(), 12), 1)), dateToDateString(new Date())],
    },
    MONTH_TO_DATE: {
        label: 'Month to date',
        value: () => [dateToDateString(startOfMonth(new Date())), dateToDateString(new Date())],
    },
    CUSTOM: {
        label: 'Custom',
        value: () => [null, null],
    },
};

export { DATE_RANGE_PRESETS as D };

//# sourceMappingURL=constants.js.map